module.exports = __webpack_public_path__ + "img/logox.3b2c652b.png";